<template>
  <div>
    <a-badge dot>
      <a-button size="small" icon="el-icon-chat-round" @click="showDrawer" shape="round">
        <span class="hidden-sm-and-down">選課系統</span>
        <a-icon type="edit"/>
      </a-button>
    </a-badge>
    <el-drawer
        :modal="false"
        :visible.sync="isDrawerShow"
        :before-close="handleClose"
        :show-close="false"
        direction="rtl"
        size="70%">
      <el-button @click="isDrawerShow = false">關閉選課系統</el-button>
      <iframe height="100%" src="https://course.nctu.edu.tw/"
              width="100%"/>
    </el-drawer>

  </div>
</template>
<script>

export default {
  name: 'course-select-system',
  data() {
    return {
      isDrawerShow: false,
      isWarned: false
    }
  },
  methods: {
    showDrawer() {
      if (this.isWarned) {
        this.isDrawerShow = true
        return
      }
      this.$alert(
          `由於學校選課系統的限制，此功能需關閉<strong">隱私設定</strong>，
                     否則會無法登入系統。請務必在選課完成後復原設定。
                     <br>若要繼續使用，請使用chrome前往以下網址，<br>並調整"SameSite by default cookies"為「Disabled/關閉」。
`,
          '使用前須知', {
            showCancelButton: true,
            showClose: false,
            confirmButtonText: '打開選課系統',
            cancelButtonText: '了解更多',
            type: 'warning',
            dangerouslyUseHTMLString: true,
            showInput: true,
            inputValue: 'chrome://flags/#same-site-by-default-cookies'
          }).then(() => {
        this.isDrawerShow = true
        this.isWarned = true
      }).catch(() => {
        window.open(
            'https://medium.com/@azure820529/chrome-80-%E5%BE%8C%E9%87%9D%E5%B0%8D%E7%AC%AC%E4%B8%89%E6%96%B9-cookie-%E7%9A%84%E8%A6%8F%E5%89%87%E8%AA%BF%E6%95%B4-default-samesite-lax-aaba0bc785a3'// <- This is what makes it open in a new window.
        );
      });
    },
    handleClose() {
    }
  },
  computed: {}
}
</script>
